import { useState } from 'react';

import SimpleTooltip from './tooltips/SimpleTooltip';
import StageTooltip from './tooltips/StageTooltip';
import StatusTooltip from './tooltips/StatusTooltip';
import TitleTooltip from './tooltips/TitleTooltip';
import AppToRevCellText from './AppToRevCellText';
import StyledWrapper from '../../IndividualProgram/style';
import { checkOverflow } from '../../../utils/utilFunctions';
import ApplicantProcess from '../../../assets/customIcons/applicantProcess';
import ReviewColorStageIcon from '../../../assets/customIcons/reviewColorStageIcon';
import { getStatusColor, getChipTextColor, isDecisionChip } from '../../../utils/utilFunctions';
import DecisionChip from '../../../components/core/DecisionChip/DecisionChip';

import { Tooltip, Chip } from '@mui/material';

const ApplicationToReviewColumns = (columnWidths) => {
	const [openTooltip, setOpenTooltip] = useState(0);

	return [
		{
			field: 'submitter',
			headerName: 'Submitter',
			renderCell: (cellValues) => <SimpleTooltip cellValues={cellValues} />,
			flex: columnWidths.title || 1,
			resizable: true
		},
		{
			field: 'submissionDate',
			headerName: 'Submission Date',
			renderCell: (cellValues) => <SimpleTooltip cellValues={cellValues} />,
			flex: columnWidths.submissionDate || 1,
			maxWidth: 175,
			resizable: true,
			// Backend orders only by exact model field names; this camelCase
			// display field has no matching column/property, so server sort is a
			// silent no-op. Disable until a real ordering key is wired up.
			sortable: false
		},
		{
			field: 'title',
			headerName: 'Application (Project Title)',
			renderCell: (cellValues) => <TitleTooltip cellValues={cellValues} />,
			valueGetter: (params) =>
				params?.row?.displayId
					? `${params?.row?.title} [${params?.row?.displayId}]`
					: params?.row?.title,
			flex: columnWidths.title || 1,
			resizable: true
		},
		{
			field: 'stageName',
			headerName: 'Evaluation Stage Name',
			renderCell: (cellValues) => <StageTooltip cellValues={cellValues} />,
			flex: !columnWidths.stageName && 1,
			resizable: true
		},
		{
			field: 'status',
			headerName: 'Stage Status',
			renderCell: (cellValues) => <StatusTooltip cellValues={cellValues} />,
			flex: !columnWidths.status && 1,
			maxWidth: 175
		},
		{
			field: 'applicationStatus',
			headerName: 'Application Status',
			renderCell: (cellValues) =>
				cellValues?.formattedValue ? (
					<Tooltip
						open={openTooltip === `applicationStatus-${cellValues?.id}`}
						onOpen={(e) =>
							checkOverflow(e) && setOpenTooltip(`applicationStatus-${cellValues?.id}`)
						}
						onClose={() => setOpenTooltip(0)}
						arrow
						placement="top"
						title={cellValues?.formattedValue}
					>
						{isDecisionChip(cellValues?.formattedValue) ? (
							<DecisionChip label={cellValues?.formattedValue} />
						) : (
							<Chip
								data-testid={`${cellValues?.field}-${cellValues?.id}`}
								label={cellValues?.formattedValue}
								sx={{
									backgroundColor: getStatusColor(cellValues?.formattedValue),
									color: getChipTextColor(cellValues?.formattedValue)
								}}
								size="small"
							/>
						)}
					</Tooltip>
				) : null,
			flex: !columnWidths.applicationStatus && 1,
			minWidth: 150,
			// Computed status, not a DB column; server sort cannot order it
			// (would only ever hit the expensive in-memory path), so disable it.
			sortable: false
		},
		{
			field: 'totalReviewers',
			headerName: 'Number of Reviewers',
			renderCell: (cellValues) => (
				<AppToRevCellText
					openTooltip={openTooltip}
					setOpenTooltip={setOpenTooltip}
					cellValues={cellValues}
				/>
			),
			flex: columnWidths.reviewer || 1,
			maxWidth: 205,
			type: 'number',
			headerAlign: 'left',
			align: 'left',
			resizable: true
		},
		{
			field: 'reviewers',
			headerName: 'Assigned Reviewers',
			renderCell: (cellValues) => <SimpleTooltip cellValues={cellValues} />,
			flex: columnWidths.reviewFormName || 1,
			resizable: true
		}
	];
};

export default ApplicationToReviewColumns;
